import { EMAIL_RULES } from '@/utils/validationRules';
import { Button, CircularProgress, FormLabel, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { sendPasswordResetRequest } from './data';

const FormView = ({ setEmailSent }) => {
  const [loading, setLoading] = useState(false);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async data => {
    setLoading(true);
    try {
      await sendPasswordResetRequest(data.email);
      setLoading(false);
      setEmailSent(true);
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
      setLoading(false);
    }
    return;
  };

  if (loading) {
    return (
      <div className='flex justify-center'>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <h1 className='font-bold text-[32px] text-[#121212] mb-[4px]'>Forgot Password</h1>
      <div className='text-[#84818A] text-[14px] font-medium mb-[32px]'>
        You can use this form to recover your password if you have forgotten it. Enter your email address below to get
        started.
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormLabel htmlFor='email-input'>Email</FormLabel>
        <Controller
          name='email'
          control={control}
          rules={EMAIL_RULES}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              id='email-input'
              type='email'
              error={!!error}
              helperText={error?.message}
              fullWidth
              sx={{
                marginBottom: '26px',
              }}
              slotProps={{
                htmlInput: { placeholder: 'hi@example.com' },
              }}
            />
          )}
        />
        <Button
          sx={{
            height: 48,
            fontWeight: 700,
            marginBottom: '16px',
          }}
          type='submit'
          variant='contained'
          fullWidth
        >
          Send Email
        </Button>
        <Link to='/'>
          <Button
            sx={{
              height: 48,
              fontWeight: 700,
            }}
            type='reset'
            variant='outlined'
            fullWidth
          >
            Go back to Login
          </Button>
        </Link>
      </form>
    </>
  );
};

FormView.propTypes = {
  setEmailSent: PropTypes.func,
};

export default FormView;
